import { Injectable } from '@angular/core';
import {
  Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from '@angular/router';
import { IAppState } from '@app/store/state/app.state';
import { Store } from '@ngrx/store';
import { AuthService } from './auth.service';
import * as AuthSelectors from '@store/selectors/auth.selectors';
import { tap } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class RoleGuard {
  user$ = this.store
    .select(AuthSelectors.selectUser)
    .pipe(
      tap((user) => {
        if (Array.isArray(user?.roleNames)) {
          this.userRoles = user?.roleNames;
        } else {
          this.userRole = user?.roleNames as unknown as string;
        }
      }),
    )
    .subscribe();

  userRoles: string[];
  userRole: string;

  constructor(
    private router: Router,
    private authService: AuthService,
    private store: Store<IAppState>,
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): boolean {
    const loggedIn = this.authService.isLoggedIn();
    // Case-insensitive so 'Admin'/'ADMIN' match the route's required roles.
    const roles = (route.data.roles as Array<string>).map((r) =>
      r.toLowerCase(),
    );
    if (
      loggedIn && Array.isArray(this.userRoles)
        ? this.userRoles.some((userRole) =>
            roles.includes(userRole?.toLowerCase()),
          )
        : roles.includes(this.userRole?.toLowerCase())
    ) {
      this.user$.unsubscribe();
      return true;
    }
    this.user$.unsubscribe();

    // not logged in so redirect to login page with the return url
    this.router.navigate(['/customer/search'], {
      queryParams: { returnUrl: state.url },
    });
    return false;
  }
}
